import { BundleProduct } from './ResponsiveBuildYourOwnBundleProducts'

export const INITIAL_QUANTITY = 1

export const removeProduct = (
  sku: number,
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void,
) => {
  setSelectedBundleProducts((currentProducts) =>
    currentProducts.filter((selectedProduct) => selectedProduct.sku !== sku),
  )
}

export const addProduct = (
  sku: number,
  categoryId: string,
  productPrice: number,
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void,
  setSelectedQuantity: (selectedQuantity: number) => void,
) => {
  setSelectedBundleProducts((currentBundle) => [
    ...currentBundle,
    {
      sku,
      categoryId,
      quantity: 1,
      price: productPrice,
    },
  ])
  setSelectedQuantity(INITIAL_QUANTITY)
}

export const replaceLastSelectedProduct = (
  sku: number,
  categoryId: string,
  productPrice: number,
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void,
  productsInCategory: BundleProduct[],
  isBundleFull: boolean,
  numberOfProductsInSelectedCategory: number,
  maxProductsPerCategory: number,
  setSelectedQuantity: (selectedQuantity: number) => void,
) => {
  const canStillSelectFromOtherCategories =
    numberOfProductsInSelectedCategory < maxProductsPerCategory

  if (
    isBundleFull &&
    canStillSelectFromOtherCategories &&
    numberOfProductsInSelectedCategory === 0
  ) {
    setSelectedBundleProducts((currentBundle) =>
      currentBundle.filter(
        (selectedProduct) =>
          selectedProduct.sku !== currentBundle[currentBundle.length - 1].sku,
      ),
    )

    addProduct(
      sku,
      categoryId,
      productPrice,
      setSelectedBundleProducts,
      setSelectedQuantity,
    )
  } else {
    setSelectedBundleProducts((currentBundle) => {
      return [
        ...currentBundle.filter(
          (selectedProduct) =>
            selectedProduct.sku !==
            productsInCategory[productsInCategory.length - 1].sku,
        ),
      ]
    })

    addProduct(
      sku,
      categoryId,
      productPrice,
      setSelectedBundleProducts,
      setSelectedQuantity,
    )
  }
}

export const handleProductSelection = (
  sku: number,
  categoryId: string,
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void,
  maxProductsPerCategory: number,
  productPrice: number,
  isBundleFull: boolean,
  productsInCategory: BundleProduct[],
  isProductSelected: boolean,
  numberOfProductsInSelectedCategory: number,
  setSelectedQuantity: (selectedQuantity: number) => void,
) => {
  const canAddProduct =
    !isProductSelected &&
    !isBundleFull &&
    (!maxProductsPerCategory ||
      numberOfProductsInSelectedCategory < maxProductsPerCategory)

  const canReplaceProduct =
    !isProductSelected &&
    (isBundleFull ||
      numberOfProductsInSelectedCategory === maxProductsPerCategory)

  if (canAddProduct) {
    addProduct(
      sku,
      categoryId,
      productPrice,
      setSelectedBundleProducts,
      setSelectedQuantity,
    )
  } else if (canReplaceProduct) {
    replaceLastSelectedProduct(
      sku,
      categoryId,
      productPrice,
      setSelectedBundleProducts,
      productsInCategory,
      isBundleFull,
      numberOfProductsInSelectedCategory,
      maxProductsPerCategory,
      setSelectedQuantity,
    )
  }
}

export const handleUpdateQuantity = (
  sku: number,
  newQuantity: number,
  setSelectedBundleProducts: (
    callback: (currentProducts: BundleProduct[]) => BundleProduct[],
  ) => void,
  setSelectedQuantity: (selectedQuantity: number) => void,
) => {
  setSelectedQuantity(newQuantity)

  setSelectedBundleProducts((currentBundle) => {
    return currentBundle.map((selectedProduct) => {
      if (selectedProduct.sku === sku) {
        return {
          ...selectedProduct,
          quantity: newQuantity,
        }
      }
      return selectedProduct
    })
  })
}

export const computeMaxQuantity = (
  maxVariantsPerCategory: number,
  numberOfProductsInSelectedCategory: number,
  selectedQuantity: number,
  availableBundleQuantity: number,
) => {
  const maxPerCategory =
    maxVariantsPerCategory -
    numberOfProductsInSelectedCategory +
    selectedQuantity
  const maxPerBundle = availableBundleQuantity + selectedQuantity
  return Math.min(maxPerCategory, maxPerBundle)
}
